export default "__VITE_ASSET__CObdEUUk__"